import { render, staticRenderFns } from "./EdgeProp.vue?vue&type=template&id=22f1d689&scoped=true"
import script from "./EdgeProp.vue?vue&type=script&lang=js"
export * from "./EdgeProp.vue?vue&type=script&lang=js"
import style0 from "./EdgeProp.vue?vue&type=style&index=0&id=22f1d689&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1d689",
  null
  
)

export default component.exports